// @ts-nocheck

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { http } from "../../../engine/api/http";

const initialState = {
  logs: [],
  loading: false,
  totals: {},
};

export const getLogs = createAsyncThunk(
  "logs/getLogs",
  async (payload, thunkAPI) => {
    const { search } = payload;

    const res = await http.get(`/logs?${search}`);
    return res.data;
  },
);

const logsSlice = createSlice({
  name: "logs",
  initialState,
  reducers: {},
  extraReducers: {
    [getLogs.pending]: state => {
      state.loading = true;
    },
    [getLogs.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.logs = payload.logs;
      state.totals = payload.totals;
    },
    [getLogs.rejected]: state => {
      state.loading = false;
    },
  },
});

export const {
  increment,
  decrement,
  incrementByAmount,
  updateUnitOnList,
} = logsSlice.actions;

export const logsReducer = logsSlice.reducer;
